export const NEWS_RESEARCH_SETTINGS_STARTED = 'NEWS_RESEARCH_SETTINGS_STARTED';
export const UPDATE_NEWS_RESEARCH_SETTINGS_STARTED = 'UPDATE_NEWS_RESEARCH_SETTINGS_STARTED';
export const UPDATE_NEWS_RESEARCH_SETTINGS = 'UPDATE_NEWS_RESEARCH_SETTINGS';
export const NEWS_RESEARCH_SETTINGS_FAILURE = 'NEWS_RESEARCH_SETTINGS_FAILURE';
export const NEWS_RESEARCH_RESULT_CLEAR_DATA = 'NEWS_RESEARCH_RESULT_CLEAR_DATA';
export const NEWS_RESEARCH_RESULT_STARTED = 'NEWS_RESEARCH_RESULT_STARTED';
export const NEWS_RESEARCH_RESULT_UPDATE = 'NEWS_RESEARCH_RESULT_UPDATE';
export const NEWS_RESEARCH_RESULT_SUCCESS = 'NEWS_RESEARCH_RESULT_SUCCESS';
export const NEWS_RESEARCH_RESULT_FAILURE = 'NEWS_RESEARCH_RESULT_FAILURE';